// extracted by mini-css-extract-plugin
export default {"InputSlider":"InputSlider_InputSlider__eV+nG","InputSlider__label":"InputSlider_InputSlider__label__PpuaJ","InputSlider__group":"InputSlider_InputSlider__group__ZSqYx"};